// libs
import { styled } from '@nykaa/ui-components';

// animations
import shakeCss from 'shared/styles/animations/shake';

// constants
import { BREAKPOINTS, HIDE_SCROLLBARS } from 'shared/styles/base';

//components
import TertiaryTitle from '../TertiaryTitle';

export const SizeOptionContainer = styled.section<{ shake?: boolean; }>`
  margin: ${({ theme }) => `${theme.spacing.spacing120} 0 0`};
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ theme }) => theme.colors.textPrimary};
  width: 100%;
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    margin-top: ${({ theme }) => theme.spacing.spacing80};
    ${({ theme }) => theme.typography.titleMedium};
  }

  ${({ shake = false }) => shake && shakeCss};
`;

export const BodyMeasContainer = styled.div`
  @media (min-width: ${BREAKPOINTS.TABLET}px) and (max-width: ${BREAKPOINTS.DESKTOP}px) {
    text-align: center;
  }
`;

export const BodyMeasTitle = styled.div`
  ${({ theme }) => theme.typography.subTitleSmall};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
  text-transform: capitalize;
`;

export const BodyPart = styled.span`
  &:after {
    content: '|';
    padding: ${({ theme }) => `0 ${theme.spacing.spacing40}`};
    ${({ theme }) => theme.typography.bodyXSmall};
  }

  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    &:last-child {
      &:after {
        display: none;
      }
    }
  }
`;

export const SizeGuideButton = styled.button<{ isSizeSelectorV2: boolean; }>`
  ${({ theme }) => theme.typography.buttonLarge};
  color: ${({ theme }) => theme.colors.secondary};
  background: none;
  border: none;
  text-decoration: underline;
  cursor: pointer;
  display: inline;
  text-decoration: none;
  float: right;
  ${({ isSizeSelectorV2, theme }) =>
    !isSizeSelectorV2 && `margin-left: ${theme.spacing.spacing80};`};
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    float: right;
    padding: 0;
    ${({ theme }) => theme.typography.buttonMedium};
  }
`;

export const SizeBtnContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  margin-left: ${({ theme }) => `-${theme.spacing.spacing80}`};
  margin-right: ${({ theme }) => `-${theme.spacing.spacing80}`};
  padding-left: ${({ theme }) => theme.spacing.spacing80};
  padding-right: ${({ theme }) => theme.spacing.spacing80};
  margin-top: ${({ theme }) => theme.spacing.spacing80}; 

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    gap: ${({ theme }) => theme.spacing.spacing80} 0;
  }

  @media (min-width: ${BREAKPOINTS.TABLET}px) and (max-width: ${BREAKPOINTS.DESKTOP}px) {
    justify-content: center;
  }
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    width: 100vw;
    flex-wrap: unset;
    flex-flow: row;
    overflow-y: scroll;
    ${HIDE_SCROLLBARS};
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: ${({ theme }) => theme.spacing.spacing50};
`;

export const TitleContainerV2 = styled(TitleContainer)`
  margin-bottom: ${({ theme }) => theme.spacing.spacing10};
`;

export const SizeGuideText = styled(TitleContainer)`
  margin-bottom: 0;
`;

export const LegendsContainer = styled.div`
  display: flex;
  ${({ theme }) => theme.typography.bodySmall};
`;

export const Legend = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.typography.bodySmall};
  span {
    margin-left: ${({ theme }) => theme.spacing.spacing20};
  }
`;

export const LegendDot = styled.div<{ isFewLeft: boolean | undefined; }>`
  width: 6px;
  height: 6px;
  border-radius: ${({ theme }) => theme.borders.radius20};
  ${({ isFewLeft, theme }) =>
    isFewLeft
      ? `
      background: ${theme.colors.warning}; 
      margin-left: ${theme.spacing.spacing80};
      `
      : `background: rgba(163, 170, 177, 1)`};
`;

export const ArrowRightIcon = styled.div`
  vertical-align: text-top;
  margin-left: ${({ theme }) => theme.spacing.spacing20};
  display: inline-flex;
`;

export const TertiaryTitleV2 = styled(TertiaryTitle)`
  margin-bottom: 0;
  ${({ theme }) => theme.typography.titleMedium};
    margin: ${({ theme }) => `0 0 ${theme.spacing.spacing10} 0`};
    color: ${({ theme }) => theme.colors.textPrimary};
  
    @media screen and (max-width: ${BREAKPOINTS.DESKTOP}px) {
      ${({ theme }) => theme.typography.titleSmall};
    }
`;

export const BottomSheetContainer = styled.div`
display: flex;
max-width: 90vw;
`;

export const SizeGuideNudgeContainer = styled.div``;